import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { BaseComponent } from '../../../../../../shared/components/base/base.component';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { FormControl, NgForm } from '@angular/forms';
import { MatSelect, MatOption } from '@angular/material';
import { DocumentTypeService } from '../../../../../../core/services/document-type.service';
import { DocumentTemplateService } from '../../../../../../core/services/document-template.service';
import { UserService } from '../../../../../../core/services/user.service';
import { DocumentService } from '../../../../../../core/services/document.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../../../../../core/services/notification.service';
import { CommonService } from '../../../../../../core/services/common.service';
import { Message } from '../../../../../../core/class/message';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { EnumContractStatus } from '../../../../../../core/constants/contract';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { ReportService } from '../../../../../../core/services/report.service';
import FileUtils from '../../../../../../core/services/file-utils';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import moment from 'moment';
@Component({
  selector: 'app-contract-enterprise-create',
  templateUrl: './contract-enterprise-create.component.html',
  styleUrls: ['./contract-enterprise-create.component.scss']
})
export class ContractEnterpriseCreateComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Check status of document for process update
   */
  checkUpdateDocument = false;
  public warningContractQuantity = false;
  public mediaBreakpoint: any;
  public SCREEN_SIZE = SCREEN_SIZE;
  mode = 2;
  subscription: Subscription;
  enterpriseId;
  checkFocus = true;
  createdDateErr = '';
  expiredDateErr = '';
  @ViewChild('myForm', { static: false }) ngForm: NgForm;
  @ViewChild('groupForm', { static: false }) groupForm: NgForm;

  @ViewChild('timePeriod', { static: false }) timePeriod: MatSelect;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('allSelectedBranch', { static: false }) allSelectedBranch: MatOption;
  @ViewChild('branchesSelect', { static: false }) branchesSelect: MatSelect;
  @ViewChild('allSelectedUserCreated', { static: false }) allSelectedUserCreated: MatOption;
  @ViewChild('createdUserSelect', { static: false }) createdUserSelect: MatSelect;
  @ViewChild('allSelectedCustomer', { static: false }) allSelectedCustomer: MatOption;
  @ViewChild('signCustomerSelect', { static: false }) signCustomerSelect: MatSelect;
  @ViewChild('allSelectedServiceType', { static: false }) allSelectedServiceType: MatOption;
  @ViewChild('serviceTypeSelect', { static: false }) serviceTypeSelect: MatSelect;
  @ViewChild('allSelectedStatus', { static: false }) allSelectedStatus: MatOption;
  @ViewChild('allSelectedResource', { static: false }) allSelectedResource: MatOption;
  @ViewChild('statusSelect', { static: false }) statusSelect: MatSelect;
  @ViewChild('resourceSelect', { static: false }) resourceSelect: MatSelect;
  @ViewChild('typeIdSelect', {static: false}) typeIdSelect: MatSelect;
  @ViewChild('templateSelect', {static: false}) templateSelect: MatSelect;
  @ViewChild('allSelectedTemplate', {static: false}) allSelectedTemplate: MatOption;

  documents = new Documents();
  exportForm: any;
  EnumContractStatus = EnumContractStatus;

  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  serviceTypes: comboBox[] = [];
  serviceTypesFilterCtrl: FormControl = new FormControl();

  public filteredBranches: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  branchesFilterCtrl: FormControl = new FormControl();
  branches: comboBox[] = [];
  selectBranchMap = new Map();

  public filteredCreatedUser: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  createdUserFilterCtrl: FormControl = new FormControl();
  createdUsers: comboBox[] = [];
  selectCreatedUserMap = new Map();

  public filteredSignCustomer: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  signCustomerFilterCtrl: FormControl = new FormControl();
  signCustomers: comboBox[] = [];
  selectSignCustomerMap = new Map();

  public filteredTemplates: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  templateFilterCtrl: FormControl = new FormControl();
  templates: comboBox[] = [];

  sortName = '';
  sortType = '';

  // tslint:disable-next-line:variable-name
  private _onDestroy = new Subject<void>();
  showSpinner = false;

  isNotAttestedUser: boolean = false;
  isExpanded = true;
  signedDateErr: string;

  constructor(
    private documentTypeService: DocumentTypeService,
    private documentTemplateService: DocumentTemplateService,
    private usService: UserService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private reportService: ReportService,
    private spinnerService: Ng4LoadingSpinnerService,
    private toastr: ToastrService,
    public translateService: TranslateService
  ) {
    super(commonService, message);
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  ngOnInit() {
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);

    // this.commonService.aut
    // this.filteredBranches =

    this.serviceTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
        });

    this.branchesFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.branches, this.branchesFilterCtrl, this.filteredBranches);
        });

    this.createdUserFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.createdUsers, this.createdUserFilterCtrl, this.filteredCreatedUser);
        });

    this.signCustomerFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.signCustomers, this.signCustomerFilterCtrl, this.filteredSignCustomer);
        });

    this.templateFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.templates, this.templateFilterCtrl, this.filteredTemplates);
        });

    this.getServiceTypeByEnterprise();
    this.getBranches();
    this.getCreatedUser();
    this.getSignCustomer();
    this.getTemplates();

    // this.branchesFilterCtrl.valueChanges.
  }

  ngAfterViewInit(page: number = 0) {
    // setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Get data when init
   */
  loadData() {
  }

  onExportReport() {
    console.log('send info excel', this.documents);
    if (this.sortName && this.sortType) {
      this.documents.sorts = { [this.sortName]: this.sortType };
    } else {
      this.documents.sorts = {}
    }
    if(this.documents.customerId){
      this.documents.customerId = this.documents.customerId.filter((item) => {
        return item !== undefined
      })
    }
    if(this.documents.enterpriseId){
      this.documents.enterpriseId = this.documents.enterpriseId.filter((item) => {
        return item !== undefined
      })
    }
    if(this.documents.createdUserId){
      this.documents.createdUserId = this.documents.createdUserId.filter((item) => {
        return item !== undefined
      })
    }
    // this.documents.createdUserId = this.documents.createdUserId.filter((item) => {
    //   return item !== undefined
    // })
    this.exportForm = _.cloneDeep(this.documents)
    //   this.showSpinner = true;
    //   this.spinnerService.show();
    //   this.reportService.exportContractEnterpriseCreateQuantity(this.documents).subscribe(rs => {
    //     if (rs && rs.size > 0) {
    //       this.toastr.success(this.translateService.instant('toastr_report.download_success'));
    //       FileUtils.downLoadFile(rs, 'application/octet-stream', 'Bao_cao_hop_dong_cong_ty_lap.xls');
    //     } else {
    //       this.toastr.warning(this.translateService.instant('toastr_report.no_content'));
    //     }
    //     this.showSpinner = false;
    //     this.spinnerService.hide();
    //   }, err => {
    //     this.spinnerService.hide();
    //     this.toastr.error(this.translateService.instant('toastr_report.download_error'));
    // });
  }

  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.commonService.getEnterpriseFilterMineServiceType(enterpriseId).subscribe(rs => {
      if (rs && rs.data) {
        this.serviceTypes = rs.data;
        this.filteredServiceTypes.next(rs.data.slice());
      }
    });
  }

  getBranches(filter: string = '') {
    this.commonService.getAutoCompleteBranches(filter).subscribe(rs => {
      if (rs && rs.data) {
        const listToAdd = rs.data.slice();
        const selectedBranchAdd = this.selectBranchMap.values();
        if (this.commonService.isNullOrEmpty(filter)) {
          for (const branch of selectedBranchAdd) {
            const exist = rs.data.findIndex(el => el.id === branch.id) > -1;
            if (!exist) {
              listToAdd.unshift(branch);
            }
          }
        }
        this.filteredBranches.next(listToAdd);
        this.branches = listToAdd;
      }
    });
  }

  clickOptionServiceTypeAll() {
    // if (this.documents.serviceTypeId.length > 1) {
    //   this.documents.serviceTypeId = [-1];
    // }

    if (this.allSelectedServiceType.selected) {
      this.serviceTypeSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.serviceTypeSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  clickOptionServiceType() {
    // if (this.documents.serviceTypeId[0] === -1 && this.documents.serviceTypeId.length > 1) {
    //   this.documents.serviceTypeId = this.documents.serviceTypeId.filter(id => id !== -1);
    // }

    if (this.allSelectedServiceType.selected) {
      this.allSelectedServiceType.deselect();
    }
    if (this.serviceTypeSelect.options.length - 2 == this.documents.serviceTypeId.length) {
      this.allSelectedServiceType.select();
    }
  }

  clickOptionStatusAll() {
    // if (this.documents.status.length > 1) {
    //   this.documents.status = [-1];
    // }

    if (this.allSelectedStatus.selected) {
      this.statusSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.statusSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  clickOptionStatus() {
    // if (this.documents.status[0] === -1 && this.documents.status.length > 1) {
    //   this.documents.status = this.documents.status.filter(id => id !== -1);
    // }

    if (this.allSelectedStatus.selected) {
      this.allSelectedStatus.deselect();
    }
    if (this.statusSelect.options.length - 1 == this.documents.status.length) {
      this.allSelectedStatus.select();
    }
  }

  clickOptionResourceAll() {
    if (this.allSelectedResource.selected) {
      this.resourceSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.resourceSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  clickOptionResource() {
    if (this.allSelectedResource.selected) {
      this.allSelectedResource.deselect();
    }
    if (this.resourceSelect.options.length - 1 == this.documents.typeEnterpriseResource.length) {
      this.allSelectedResource.select();
    }
  }

  clickOptionBranchesAll() {
    // if (this.documents.enterpriseId.length > 1) {
    //   this.documents.enterpriseId = [-1];
    // }

    if (this.allSelectedBranch.selected) {
      this.branchesSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.branchesSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }

    this.selectBranchMap.clear();
  }

  clickOptionBranches(branch) {
    if (this.selectBranchMap.has(branch.id)) {
      this.selectBranchMap.delete(branch.id);
    } else {
      this.selectBranchMap.set(branch.id, branch);
    }
    // if (this.documents.enterpriseId[0] === -1 && this.documents.enterpriseId.length > 1) {
    //   this.documents.enterpriseId = this.documents.enterpriseId.filter(id => id !== -1);
    // }
    if (this.allSelectedBranch.selected) {
      this.allSelectedBranch.deselect();
    }
    if (this.branchesSelect.options.length - 2 == this.documents.enterpriseId.length) {
      this.allSelectedBranch.select();
    }
  }

  clickOptionBranches2(id) {
    if (this.selectBranchMap.has(id)) {
      this.selectBranchMap.delete(id);
    } else {
      this.selectBranchMap.set(id, id);
    }
    // if (this.documents.enterpriseId[0] === -1 && this.documents.enterpriseId.length > 1) {
    //   this.documents.enterpriseId = this.documents.enterpriseId.filter(id => id !== -1);
    // }
    if (this.allSelectedBranch.selected) {
      this.allSelectedBranch.deselect();
    }
    if (this.branchesSelect.options.length - 2 == this.documents.enterpriseId.length) {
      this.allSelectedBranch.select();
    }
  }

  clickOptionCreatedUserAll() {
    // if (this.documents.createdUserId.length > 1) {
    //   this.documents.createdUserId = [-1];
    // }
    if (this.allSelectedUserCreated.selected) {
      this.createdUserSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.createdUserSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.selectCreatedUserMap.clear();
  }

  clickOptionCreatedUser(createdUser) {
    if (this.selectCreatedUserMap.has(createdUser.id)) {
      this.selectCreatedUserMap.delete(createdUser.id);
    } else {
      this.selectCreatedUserMap.set(createdUser.id, createdUser);
    }
    // if (this.documents.createdUserId[0] === -1 && this.documents.createdUserId.length > 1) {
    //   this.documents.createdUserId = this.documents.createdUserId.filter(id => id !== -1);
    // }
    if (this.allSelectedUserCreated.selected) {
      this.allSelectedUserCreated.deselect();
    }
    if (this.createdUserSelect.options.length - 2 == this.documents.createdUserId.length) {
      this.allSelectedUserCreated.select();
    }
  }

  clickOptionCreatedUsers(createdUser) {
    if (this.selectCreatedUserMap.has(createdUser)) {
      this.selectCreatedUserMap.delete(createdUser);
    } else {
      this.selectCreatedUserMap.set(createdUser.id, createdUser);
    }
    // if (this.documents.createdUserId[0] === -1 && this.documents.createdUserId.length > 1) {
    //   this.documents.createdUserId = this.documents.createdUserId.filter(id => id !== -1);
    // }
    if (this.allSelectedUserCreated.selected) {
      this.allSelectedUserCreated.deselect();
    }
    if (this.createdUserSelect.options.length - 2 == this.documents.createdUserId.length) {
      this.allSelectedUserCreated.select();
    }
  }

  getCreatedUser(filter: string = '') {
    this.commonService.getAutoCompleteCreatedUser(filter).subscribe(rs => {
      if (rs && rs.data) {
        const listToAdd = rs.data.slice();
        const selectedList = this.selectCreatedUserMap.values();
        if (this.commonService.isNullOrEmpty(filter)) {
          for (const item of selectedList) {
            const exist = rs.data.findIndex(el => el.id === item.id) > -1;
            if (!exist) {
              listToAdd.unshift(item);
            }
          }
        }
        this.filteredCreatedUser.next(listToAdd);
        this.createdUsers = listToAdd;
      }
    });
  }

  clickOptionSignCustomerAll() {
    // if (this.documents.customerId.length > 1) {
    //   this.documents.customerId = [-1];
    // }
    if (this.allSelectedCustomer.selected) {
      this.signCustomerSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.signCustomerSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.selectSignCustomerMap.clear();
  }

  clickOptionSignCustomer(signCustomer) {
    if (signCustomer) {
      if (this.selectSignCustomerMap.has(signCustomer.id)) {
        this.selectSignCustomerMap.delete(signCustomer.id);
      } else {
        this.selectSignCustomerMap.set(signCustomer.id, signCustomer);
      }
    } else {
      if (this.selectSignCustomerMap.has(0)) {
        this.selectSignCustomerMap.delete(0);
      } else {
        this.selectSignCustomerMap.set(0, 0);
      }
    }
    // if (this.documents.customerId[0] === -1 && this.documents.customerId.length > 1) {
    //   this.documents.customerId = this.documents.customerId.filter(id => id !== -1);
    // }
    if (this.allSelectedCustomer.selected) {
      this.allSelectedCustomer.deselect();
    }
    if (this.signCustomerSelect.options.length - 2 == this.documents.customerId.length) {
      this.allSelectedCustomer.select();
    }
  }

  getSignCustomer(filter: string = '') {
    this.commonService.getAutoCompleteSignCustomer(filter).subscribe(rs => {
      if (rs && rs.data) {
        const listToAdd = rs.data.slice();
        const selectedList = this.selectSignCustomerMap.values();
        if (this.commonService.isNullOrEmpty(filter)) {
          for (const item of selectedList) {
            const exist = rs.data.findIndex(el => el.id === item.id) > -1;
            if (!exist) {
              listToAdd.unshift(item);
            }
          }
        }
        this.filteredSignCustomer.next(listToAdd);
        this.signCustomers = listToAdd;
      }
    });
  }

  getTemplates() {
    this.documentService.getDocumentsType().subscribe(rs => {
      if (rs && rs.data) {
        this.templates = rs.data.map((item: any) => ({
          id: item.id,
          name: item.name
        }));
        this.filteredTemplates.next([...this.templates]);
      }
    });
  }

  clickOptionTemplateAll() {
    if (this.allSelectedTemplate.selected) {
      this.templateSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.templateSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  clickOptionTemplate() {
    if (this.allSelectedTemplate.selected) {
      this.allSelectedTemplate.deselect();
    }
    if (this.templateSelect.options.length - 2 === this.documents.templateIds.length) {
      this.allSelectedTemplate.select();
    }
  }

  onChangeSortSelection() {
    if (this.sortName === 'expiredDate' || this.sortName === 'createdTime') {
      this.sortType = 'DESC';
    } else if (this.sortName === 'contractCode' || this.sortName === 'contractName') {
      this.sortType = 'ASC';
    } else {
      this.sortType = '';
    }
  }

  unSelectSort() {
    this.sortName = null;
    this.sortType = null;
  }
  scrollToElement(){
    const textLayer = document.getElementById('inforReport');
    if(textLayer)
      textLayer.scrollIntoView();
  }

  clickPanel(){
    if(!this.isExpanded){
      this.isExpanded = true;
    }
  }

  filterForm(event: any) {
    this.clickPanel();
    this.scrollToElement();
    this.createdUserSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
      item.deselect();
    });
    this.documents = new Documents;
    if (!event.contractEnterpriseCreateSearchFilter) {
      window.scrollTo(0, 0);
      return
    }
    const data = event.contractEnterpriseCreateSearchFilter
    if (data && data.customerId) {
      data.customerId = data.customerId.map((item) => {
        if (item === '0')
          return +item
        else
          return item
      })
    }
    if (data.signedFromDate)
      data.signedFromDate = moment(data.signedFromDate).format('YYYY-MM-DD')
    if (data.signedToDate)
      data.signedToDate = moment(data.signedToDate).format('YYYY-MM-DD')
    if (data.createdFromDate)
    if (data.createdFromDate)
      data.createdFromDate = moment(data.createdFromDate).format('YYYY-MM-DD')
    if (data.createdToDate)
      data.createdToDate = moment(data.createdToDate).format('YYYY-MM-DD')
    if (data.expiredFromDate)
      data.expiredFromDate = moment(data.expiredFromDate).format('YYYY-MM-DD')
    if (data.expiredToDate)
      data.expiredToDate = moment(data.expiredToDate).format('YYYY-MM-DD')
    if (data.sorts) {
      if (data.sorts.expiredDate) {
        this.sortName = 'expiredDate';
        this.sortType = data.sorts.expiredDate
      } else
        if (data.sorts.createdTime) {
          this.sortName = 'createdTime';
          this.sortType = data.sorts.createdTime
        } else
          if (data.sorts.contractCode) {
            this.sortName = 'contractCode';
            this.sortType = data.sorts.contractCode
          } else
            if (data.sorts.contractName) {
              this.sortName = 'contractName';
              this.sortType = data.sorts.contractName
            } else {
              this.sortName = null
            }
    }
    this.documents = data;
    window.scrollTo(0, 0);
  }
}

export class Documents {
  status: any = [];
  serviceTypeId: any = [];
  typeEnterpriseResource: any = [];
  enterpriseId: any = [];
  createdUserId: any = [];
  customerId: any = [];
  createdFromDate: any;
  createdToDate: any;
  expiredFromDate: any;
  expiredToDate: any;
  contractCode: any;
  contractName: any;
  groupBy: any;
  sorts: any;
  signedFromDate: Date;
  signedToDate: Date;
  typeId: any;
  formType: any;
  templateIds: any = [];
}
